import { Injectable } from '@angular/core';
import { environment } from '@deltager/organizers/admin/environments/environment';
import { Observable } from 'rxjs';
import { SettlementAccount } from '@deltager/organizers/admin/shared/models/SettlementAccount';
import { HttpClient } from '@angular/common/http';
import { UserPwdChange } from '@deltager/organizers/admin/shared/models/UserPwdChange';
import { BufferTransaction, PendingBufferAmount } from '../../shared/models/buffer-transaction';

@Injectable({
  providedIn: 'root',
})
export class AccountNumberService {
  constructor(private http: HttpClient) {}

  private readonly _baseUrl = `${environment.apiBaseURL}/accountnumber`;

  getSettlementAccounts(clubid: number): Observable<SettlementAccount[]> {
    return this.http.get<SettlementAccount[]>(`${this._baseUrl}/${clubid}`);
  }

  getSettlementAccount(clubid: number, id: number): Observable<SettlementAccount> {
    return this.http.get<SettlementAccount>(`${this._baseUrl}/${clubid}/id/${id}`);
  }

  updateAccountNumber(data: SettlementAccount): Observable<boolean> {
    return this.http.put<boolean>(`${this._baseUrl}/${data.organizerId}`, data);
  }

  insertAccountNumber(data: SettlementAccount): Observable<SettlementAccount> {
    return this.http.post<SettlementAccount>(`${this._baseUrl}/${data.organizerId}`, data);
  }

  updateUserPassword(userPwdChange: UserPwdChange): Observable<boolean> {
    return this.http.put<boolean>(`${this._baseUrl}/pwd`, userPwdChange);
  }

  deleteAccountNumber(clubid: number, id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this._baseUrl}/${clubid}/id/${id}`);
  }

  checkAccountNumberNORWAY(accountnumber: string): boolean {
    if (accountnumber.length === 11) {
      const control = parseInt(accountnumber.charAt(accountnumber.length - 1), 10);
      const result = this.modolus11(accountnumber);
      if (control === result) {
        return true;
      }
    }
    return false;
  }

  checkCountrySpecificIbanValues(accountNumber: string, countryCode: string, length: number): boolean {
    if (accountNumber.length !== length) {
      return false;
    }

    if (accountNumber.substring(0, 2) !== countryCode) {
      return false;
    }

    return true;
  }

  getBufferTransactionHistory(
    accountId: number,
    clubId: number,
    pageSize: number,
    pageNumber: number,
  ): Observable<BufferTransaction[]> {
    return this.http.get<BufferTransaction[]>(
      `${this._baseUrl}/${clubId}/buffertransactions?accountId=${accountId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
    );
  }

  getPendingBufferAmounts(accountId: number, clubId: number): Observable<PendingBufferAmount> {
    return this.http.get<PendingBufferAmount>(`${this._baseUrl}/${clubId}/pendingAmounts?accountId=${accountId}`);
  }

  private modolus11(input: string): number {
    let controlNumber = 2;
    let sumForMod = 0;
    let i = 0;
    let result = 0;

    for (i = input.length - 2; i >= 0; --i) {
      sumForMod += Number.parseInt(input.charAt(i)) * controlNumber;
      if (++controlNumber > 7) {
        controlNumber = 2;
      }
    }
    result = 11 - (sumForMod % 11);
    return result === 11 ? 0 : result;
  }
}
